import React, { ReactNode } from 'react';

import { byteConverter, dateConverter } from '_utils/helpers';

import { File, Zip, Word, Excel, Movie, PDF, Image } from '_utils/icons';

const getIcon = (format: string): ReactNode => {
  switch (format.toLowerCase()) {
    case 'xls':
    case 'xlsm':
      return <Excel />;
    case 'doc':
    case 'docm':
    case 'docx':
      return <Word />;
    case 'avi':
    case 'mp4':
      return <Movie />;
    case 'pdf':
      return <PDF />;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'tiff':
    case 'svg':
    case 'gif':
      return <Image />;
    case 'zip':
    case 'gz':
    case '7z':
      return <Zip />;
    default:
      return <File />;
  }
};

const filterDownloads = (editMode: boolean, f: any): boolean =>
  editMode || (!!f.file?.jss?.value && !!f.title?.jss?.value);

const renderSize = (fileSize: string | number): ReactNode => {
  const { size, unit } = byteConverter(fileSize);

  return (
    <React.Fragment>
      {size} <abbr title={unit.LongForm}>{unit.ShortForm}</abbr>
    </React.Fragment>
  );
};

const renderDate = (date: string): ReactNode => {
  const convertedDate = dateConverter(date);

  if (convertedDate === null) {
    return null;
  }

  return <time dateTime={convertedDate.attrDate}>{convertedDate.visualDate}</time>;
};

export { getIcon, filterDownloads, renderDate, renderSize };
